import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Inventory.css';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/db';

export default function Inventory() {
  const { warehouseId, teamRoles } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      const data = await api.getItems(warehouseId);
      setItems(data);
      setLoading(false);
    }
    if (teamRoles.includes('production')) {
      navigate('/production');
      return;
    }

    if (warehouseId) load();
  }, [warehouseId, teamRoles]);

  return (
    <div className="inventory-root" dir="rtl">
      <Link to="/home"><button>رجوع</button></Link>
      {loading ? <p>جاري التحميل...</p> : (
        <table>
          <thead>
            <tr><th>البيان</th><th>الكمية</th></tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.$id}><td>{item.name}</td><td>{item.current_stock}</td></tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
